export function safeArrayAccess(indexed: string, index: number, errorMessage?: string): string;
export function safeArrayAccess<T extends NonNullable<unknown>>(indexed: T[] | readonly T[], index: number, errorMessage?: string): T;
export function safeArrayAccess<T extends NonNullable<unknown>>(indexed: T[] | readonly T[] | string, index: number, errorMessage?: string): T | string {
  const element = indexed[index];
  if (element === undefined) {
    throw new Error(errorMessage || `Array index ${index} is out of bounds or undefined`);
  }
  return element;
}
